export const configUrl = {
    AssessmentServer: process.env.REACT_APP_Assessment,
    PredictorServer: process.env.REACT_APP_PREDICTOR_SERVER, //"http://127.0.0.1:8000",
    MediNeerProviderId: 3,   //need to change as per medineer account providerId
    REACT_APP_RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY,
    contentCuratorId: [],
};

export const allowedExtensions = ["jepg", "jpg", "png", "gif", "pptx", "pdf", "docx", "xlsx"];

export const trialUserDuration = 14;
export const password = "Con@#323"

export const re = /(\.jpg|\.jpeg|\.gif|\.png|\.pdf|\.mp4|\.mov|\.wmv|\.avi|\.xlsx|\.xls|\.pptx|\.ppt|\.docx|\.doc)$/i;
export const re1 = /(\.zip)$/i;
